export default "__VITE_ASSET__B7g9Vd5T__"